import { component } from 'picoapp'
import '@/lib/jquery-global.js';

export default component(({ node }) => {

    jQuery('.js-tab').click(function() {
        jQuery('.js-tab-body').removeClass('active');
        jQuery('#' + jQuery(this).data('tab')).addClass('active');

        jQuery('.js-tab').removeClass('active');
        jQuery(this).addClass('active');
    });
    

})
